import { Injectable } from '@angular/core';

import { PayoutAcceptanceMode } from '@bpos/v1/cashout';
import { EditBetRequest } from '@bpos/v2/edit-bet';
import { EarlyPayoutConst } from 'packages/sports/web/app/src/my-bets-base/models/early-payout-types';

import { IBetslipState } from '../../../base/store/state';
import { IBetPicks } from '../../betplacement/models';
import { EarlyPayoutRequestBuilder } from '../../betplacement/services/request/early-payout-request-builder';
import PlaceBetRequestBuilder from '../../betplacement/services/request/place-bet-request-builder';

@Injectable()
export class EditBetRequestService {
    constructor(
        private placeBetRequestBuilderService: PlaceBetRequestBuilder,
        private betslipEarlyPayoutRequestBuilderService: EarlyPayoutRequestBuilder,
    ) {}

    buildEditBetRequest(betslipState: IBetslipState, requestId: string): { request: EditBetRequest; betPicks: IBetPicks } {
        const editMyBetState = betslipState.types.editBet;

        const { request: betPlacementRequest, requestPicks } = this.placeBetRequestBuilderService.buildEditBet(betslipState, requestId);

        const earlyPayoutRequest = this.betslipEarlyPayoutRequestBuilderService.build(editMyBetState);

        const editBetRequest: EditBetRequest = {
            requestId,
            topUpAmount: editMyBetState.addedStake,
            placeBetRequest: betPlacementRequest,
            cashoutRequest: {
                bet: {
                    betNumber: earlyPayoutRequest.bet.betNumber,
                    key: earlyPayoutRequest.bet.key,
                    payoutAcceptance:
                        earlyPayoutRequest.bet.acceptanceMode === EarlyPayoutConst.ModeAny
                            ? PayoutAcceptanceMode.AcceptAnyChanges
                            : PayoutAcceptanceMode.AcceptHigherPayoutAmount,
                    userExpectedPayout: earlyPayoutRequest.bet.expectedPayout,
                },
                requestId,
            },
        };

        return { request: editBetRequest, betPicks: requestPicks };
    }
}
